<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="详情"
      class="customer-edit"
      width="1000px"
      top="10vh">
    <el-table height="60vh" :data="tableData" style="width: 100%;">
      <el-table-column align="center" prop="materialCode" label="物料号" width="150"/>
      <el-table-column align="center" prop="materialDescription" label="物料描述"/>
      <el-table-column align="center" prop="requirementNum" label="需求数量" width="100px"/>
    </el-table>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <!--      <el-button :loading="submitLoading" type="primary" @click="submit">保存</el-button>-->
    </span>
  </el-dialog>
</template>

<script>

  export default {
    name:"",
    components: {},
    data() {
      return {
        dialogVisible: false,
        pkid:"",
        tableData:[],
        ruleValidate: {
        },
      };
    },
    methods: {
      open(id) {
        console.log(id);
        this.pkid = id;
        this.dialogVisible = true;
        this.getData();
      },
      getData() {
        this.$http
          .get("basic", `sAPProductionOrders/${this.pkid}`)
          .then(resp => {
            this.tableData = resp.details;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
